import { render, staticRenderFns } from "./CodeSentEmailComponent.vue?vue&type=template&id=64241bfc&scoped=true"
import script from "./CodeSentEmailComponent.vue?vue&type=script&lang=js"
export * from "./CodeSentEmailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64241bfc",
  null
  
)

export default component.exports